import { GRAMAX_MARKDOWN_LANGUAGE } from "@components/Atoms/FileInput/languageConfig/configs/markdown";

/** Every source Gramax shows in an editor is an article of its own Markdown dialect. */
export default () => GRAMAX_MARKDOWN_LANGUAGE;
